import styled from "styled-components";

export const RangeItem = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const RangeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const RangeIndex = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
`;

export const RemoveButton = styled.button`
  padding: 8px;
  background: transparent;
  border: none;
  color: #ef4444;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #fee2e2;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const WarningMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #92400e;

  svg {
    width: 18px;
    height: 18px;
    color: #f59e0b;
    flex-shrink: 0;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 6px;
  margin-top: 16px;
  font-size: 13px;
  color: #991b1b;

  svg {
    width: 18px;
    height: 18px;
    color: #ef4444;
    flex-shrink: 0;
  }
`;

export const RangeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputWrapper = styled.div`
  width: ${props => props.fullWidth ? "100%" : "auto"};
`;